import { memo } from 'react';

/**
 * #700 -- generated SVG markup, injected once. React re-applies `dangerouslySetInnerHTML` whenever
 * its `{ __html }` object is new -- every render -- replacing the SVG's nodes even when the string
 * is the same. A card re-rendering mid-touch then detached the very element under the finger, and
 * the browser stopped sending that touch to the page (a long-press drag died on the first move).
 * Memoized on the string, the nodes stay put until the markup actually changes.
 */
export const SvgMarkup = memo(function SvgMarkup({
  className,
  svg
}: {
  readonly className: string;
  readonly svg: string;
}) {
  return <div className={className} dangerouslySetInnerHTML={{ __html: svg }} />;
});
